module.exports = __webpack_public_path__ + "50d752db9cc75594ec24b089c098490b.png";